import { autoType, index } from "d3";
import React, { useReducer, useEffect } from "react";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import $ from "jquery";
import { Icon, Radio } from "semantic-ui-react";
import "./Tour.scss";
// import InteractiveIcon from "../../../assets/svg/interactive-help-icon.svg";
import Interactive_Icon from "../../../assets/svg/interactive-icon.svg";
import Interactive_Icon_Small from "../../../assets/svg/interactive-icon_smaller.svg";

import Social_media_search_Icon from "../../../assets/svg/Walkthrough-icons/Social Media Search.svg";
import Advanced_queries_Icon from "../../../assets/svg/Walkthrough-icons/advanced queries.svg";
import Customer_support_Icon from "../../../assets/svg/Walkthrough-icons/Customer support.svg";
import Account_settings_Icon from "../../../assets/svg/Walkthrough-icons/Account Settings.svg";
import Left_Menu_Icon from "../../../assets/svg/Walkthrough-icons/Left Menu.svg";
import NotificationLogo from "../../../assets/svg/notif-settings.svg";
import { useSelector } from "react-redux";
// import Advanced_queries_Icon from "../../assets/svg/Walkthrough-icons/advanced queries.svg";
// import { handleInputChange } from "react-select/src/utils";

const TOUR_STEPS = [
    {
        target: ".tour-start1",
        content: (
            <div>
                <p className="icon_header" style={{ color: "#fff", textAlign: "center" }}>
                    Welcome to Radarr!{" "}
                </p>
                <p>
                    <img src={Interactive_Icon} className="tour_image"></img>
                </p>
                <p className="tour_content">
                    {`We're so happy you're ready to find signals to help you plan digital strategy and insights. This is an interactive guide that will help you navigate the platform. To view this anywhere on the platform, click on the "Interactive Help" icon on the top right at any time.`}
                </p>
            </div>
        ),
        placement: "center",
        showSkipButton: true,
        disableBeacon: true, // This makes the tour to start automatically without clicking
    },
    {
        target: ".home_step0",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={Interactive_Icon_Small} className="tour_image_left"></img> <span className="tour_header">Switch Off Interactive Help</span>
                    <span className="tour_stepCount">1/7</span>
                </div>
                <p className="tour_content">
                    {`If you're a pro already, you can switch off the "Interactive Help" by clicking here or from the Profile section.`}
                </p>
            </div>
        ),
    },
    {
        target: ".home_step1",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={Social_media_search_Icon} className="tour_image_left"></img> <span className="tour_header">Social Media Search</span>
                    <span className="tour_stepCount">2/7</span>
                </div>
                <p className="tour_content">
                    This is a social media search engine that helps you search through billions of social media conversations. Click here to type a keyword or
                    phrase to start your search.{" "}
                </p>
            </div>
        ),
        placement: "top",
    },
    {
        target: ".home_step2",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={Advanced_queries_Icon} className="tour_image_left"></img> <span className="tour_header">Advanced Queries</span>
                    <span className="tour_stepCount">3/7</span>
                </div>
                <p className="tour_content">Click here for some examples of advanced queries you can write. </p>
            </div>
        ),
    },
    {
        target: ".notification_step1",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={NotificationLogo} className="tour_image_left"></img> <span className="tour_header">Notifications</span>
                    <span className="tour_stepCount">4/7</span>
                </div>
                <p className="tour_content">Get notified of things that are of interest to you or requires your attention.</p>
            </div>
        ),
        // placement: "center",
    },
    {
        target: ".home_step3",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={Customer_support_Icon} className="tour_image_left"></img> <span className="tour_header">Customer Support</span>
                    <span className="tour_stepCount">5/7</span>
                </div>
                <p className="tour_content">If you need to reach out to our friendly Customer Support team at any time, please click here. </p>
            </div>
        ),
    },
    {
        target: ".home_step4",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={Account_settings_Icon} className="tour_image_left"></img> <span className="tour_header">Account Settings</span>
                    <span className="tour_stepCount">6/7</span>
                </div>
                <p className="tour_content">Click here for your Account Settings, or to Logout. </p>
            </div>
        ),
    },
    {
        target: ".home_step5",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={Left_Menu_Icon} className="tour_image_left"></img> <span className="tour_header">Left Menu</span>
                    <span className="tour_stepCount">7/7</span>
                </div>
                <p className="tour_content">Left Menu has several navigational links. Click them to start exploring. </p>
            </div>
        ),
        placement: "right-middle",
        // placementBeacon: "right-start",
    },
    // {
    //     target: ".dataUsage_step1",
    //     content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat",
    // },
    // {
    //     target: ".dataUsage_step2",
    //     content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat",
    // },
    // {
    //     target: ".dataUsage_step3",
    //     content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat",
    // },
];

const INITIAL_STATE = {
    key: new Date(), // This field makes the tour to re-render when we restart the tour
    run: false,
    continuous: true,
    loading: false,
    stepIndex: 0,
    steps: TOUR_STEPS,
    checked: true,
};

// Reducer will manage updating the local state
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "START":
            return { ...state, run: true };
        case "RESET":
            return { ...state, stepIndex: 0 };
        case "STOP":
            return { ...state, run: false };
        case "NEXT_OR_PREV":
            return { ...state, ...action.payload };
        case "RESTART":
            return {
                ...state,
                stepIndex: 0,
                run: true,
                loading: false,
                key: new Date(),
            };
        default:
            return state;
    }
};

// Tour component
const Tour = () => {
    // console.log('loca',this.props.location)
    // Tour state is the state which control the JoyRide component
    const [tourState, dispatch] = useReducer(reducer, INITIAL_STATE);
    const sidebarExpanded = useSelector((state) => state.globalReducer.sidebarExpanded);

    useEffect(() => {
        // Auto start the tour if the tour is not viewed before
        if (!localStorage.getItem("tour")) {
            dispatch({ type: "START" });
        }
    }, []);

    // Set once tour is viewed, skipped or closed
    const setTourViewed = () => {
        // localStorage.setItem("tour", "1");
    };

    const callback = (data) => {
        const { action, index, type, status } = data;

        if (
            // If close button clicked, then close the tour
            action === ACTIONS.CLOSE ||
            // If skipped or end tour, then close the tour
            (status === STATUS.SKIPPED && tourState.run) ||
            status === STATUS.FINISHED
        ) {
            setTourViewed();
            dispatch({ type: "STOP" });
        } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
            // Check whether next or back button click and update the step.
            dispatch({
                type: "NEXT_OR_PREV",
                payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
            });
        }
    };

    const startTour = () => {
        // Start the tour manually
        dispatch({ type: "RESTART" });
    };

    return (
        <>
            {/* <div className="tour_toggle">
                <img src={InteractiveIcon} title="Interactive Help" className="tour-start items-center tour-link" color="blue" onClick={startTour} />
            </div> */}
            <JoyRide
                {...tourState}
                autoStart
                callback={callback}
                scrollToSteps={false}
                disableScrolling={true}
                // showSkipButton={true}
                styles={{
                    options: {
                        arrowColor: tourState.stepIndex == "7" || tourState.stepIndex == "2" ? "#fff" : "#268af6",
                        padding: 0,
                        margin: 0,
                        borderRadius: "20px",
                        spotlightShadow: "0 0 8px rgba(0, 0, 0, 0.5)",
                    },
                    spotlight: {
                        outline: "2px white",
                        outlineStyle: "dashed",
                        outlineOffset: tourState.stepIndex == "7" ? "-6px" : "-3px",
                        zIndex: 4000,
                        position: "fixed",
                        marginLeft: tourState.stepIndex == "7" ? "7px" : "",
                        maxWidth: tourState.stepIndex == "7" ? (sidebarExpanded ? "245px" : "50px") : "auto",
                    },
                    tooltipContainer: {
                        textAlign: "left",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                        padding: "0px",
                        backgroundColor: "#268af6",
                        borderRadius: "20px",
                        // borderTop: "40px solid #268af6"
                    },
                    buttonBack: {
                        backgroundColor: "rgb(239, 241, 245)",
                        color: "#000000",
                        borderRadius: "4px",
                        marginRight: "42px",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                        height: "36px",
                        minWidth: "84px",
                    },
                    buttonNext: {
                        backgroundColor: "#268af6",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                        outline: "0px",
                        marginRight: "80px",
                        height: "36px",
                        minWidth: "84px",
                    },
                    buttonClose: {
                        color: "#ffffff",
                        height: "12px",
                        width: "12px",
                        top: "-5px",
                    },
                }}
                locale={{
                    last: "Done",
                    back: "Previous",
                    skip: (
                        <button
                            type="button"
                            aria-label="Skip"
                            data-action="skip"
                            role="button"
                            title="Skip"
                            style={{
                                backgroundColor: "#eff1f5",
                                border: "0px",
                                borderRadius: "4px",
                                color: "rgb(0, 0, 0)",
                                cursor: "pointer",
                                fontSize: "14px",
                                lineHeight: "1",
                                // padding: "8px",
                                appearance: "none",
                                fontFamily: "Roboto, sans-serif",
                                height: "36px",
                                minWidth: "84px",
                                marginLeft: "80px",
                            }}>
                            Skip
                        </button>
                    ),
                }}
            />
        </>
    );
};

export default Tour;
